import React from 'react'; 
import Navbar from '../Navbar';
import Footer from '../Footer';
import AboutUsBody from './AboutUsBody';

const AboutUs = () => {
  return (
    <>
      <Navbar />
      <AboutUsBody />
      <Footer />
    </>
  );
};

export default AboutUs;